module.exports = require('./helpers/bundle-url').getBundleURL('6XdXW') + "logo-dark.eefe0b7f.svg";